// Contracts — platform: bootstrapMe.
//
// Один вход в платформу для КАЖДОГО кабинета, а не только для pothos.
// До 2026-08-16 заявка на роль (`pending_team_assignments`) забиралась
// исключительно внутри pothos-whoami, поэтому человек, которого завели
// модератором и отправили на internal.weern.com, мог зарегистрироваться,
// войти и не получить ничего: заявка молча оставалась лежать.
//
// Worker: apps/api/src/platform/publicRoutes.ts.
// Client: apps/internal/src/app/switcher/service.ts — зовётся ПЕРВЫМ,
// до проб доступа, иначе пробы увидят состояние до клейма.
import { z } from 'zod';

export const PlatformBootstrapMeReqSchema = z.object({
  /** Страна по IP, если клиент её знает. Пустая — не перетирает то, что есть. */
  country: z.string().max(8).default(''),
  language: z.string().max(16).default(''),
});
export type PlatformBootstrapMeReq = z.infer<typeof PlatformBootstrapMeReqSchema>;

export const PlatformBootstrapMeResSchema = z.object({
  ok: z.boolean(),
  /** Сколько заявок было забрано ИМЕННО этим вызовом. 0 — обычное состояние. */
  claimed: z.number().int().default(0),
  /** Роли после клейма: `javelin:javelin_moderator` и т.п. */
  memberships: z.array(z.string()).default([]),
});
export type PlatformBootstrapMeRes = z.infer<typeof PlatformBootstrapMeResSchema>;
